import { useState, useCallback } from 'react';
import {
  getInstallBannerDismissedAt,
  setInstallBannerDismissedAt,
} from '~/utils/local-storage-utils/local-storage-utils';

const TTL_MS = 30 * 24 * 60 * 60 * 1000;

const isDismissalActive = (now: number): boolean => {
  const dismissedAt = getInstallBannerDismissedAt();
  if (dismissedAt === null) {
    return false;
  }
  return now - dismissedAt < TTL_MS;
};

export interface UseInstallBannerDismissal {
  dismissed: boolean;
  dismiss: () => void;
}

export const useInstallBannerDismissal = (): UseInstallBannerDismissal => {
  const [dismissed, setDismissed] = useState<boolean>(() => isDismissalActive(Date.now()));

  const dismiss = useCallback(() => {
    setInstallBannerDismissedAt(Date.now());
    setDismissed(true);
  }, []);

  return { dismissed, dismiss };
};
